<template>
  <div v-if="visivel" class="modal-aviso-fundo" @click.self="fechar">
    <div
      class="modal-aviso"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-aviso-titulo"
      @keydown.esc="fechar"
    >
      <button type="button" class="modal-aviso-fechar" aria-label="Fechar aviso" @click="fechar">&times;</button>
      <h2 id="modal-aviso-titulo">{{ titulo }}</h2>
      <div class="modal-aviso-conteudo">
        <slot></slot>
      </div>
      <div class="modal-aviso-rodape">
        <button type="button" ref="botaoEntendi" class="modal-aviso-entendi" @click="fechar">Entendi</button>
      </div>
    </div>
  </div>
</template>

<script>
// Aviso exibido no máximo uma vez por dia em cada navegador: ao fechar, guarda a
// data de hoje; no dia seguinte o modal volta a aparecer. Para um aviso novo,
// troque a `chave`: quem já fechou o anterior hoje volta a ver o modal.

// Data local no formato AAAA-MM-DD (toISOString usaria UTC e viraria o dia às 21h).
function hoje() {
  const d = new Date();
  const mes = String(d.getMonth() + 1).padStart(2, "0");
  const dia = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mes}-${dia}`;
}

export default {
  name: "ModalAviso",
  props: {
    titulo: {
      type: String,
      required: true,
    },
    chave: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      visivel: !this.jaFoiFechado(),
    };
  },
  mounted() {
    if (this.visivel) this.$nextTick(() => this.$refs.botaoEntendi.focus());
  },
  methods: {
    // localStorage pode estar bloqueado (aba anônima, cookies desativados):
    // nesse caso o aviso aparece de novo a cada visita, sem quebrar a página.
    jaFoiFechado() {
      try {
        return localStorage.getItem(this.chave) === hoje();
      } catch (e) {
        return false;
      }
    },
    fechar() {
      this.visivel = false;
      try {
        localStorage.setItem(this.chave, hoje());
      } catch (e) {
        // sem localStorage: só fecha nesta visita
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-aviso-fundo {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-aviso {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  max-width: 32rem;
  padding: 1.5rem 1.5rem 1.25rem;
  background-color: white;
  border-top: 0.4rem solid #115810;
  border-radius: 0.5rem;
  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.3);

  h2 {
    margin: 0 1.5rem 1rem 0;
    font-size: 1.3rem;
    font-family: "Poppins-Bolder";
    color: #115810;
    text-align: center;
  }
}

.modal-aviso-conteudo {
  font-family: "Poppins-Regular";
  font-size: 0.95rem;
  line-height: 1.5;
  color: #333;
  text-align: center;

  ::v-deep p {
    margin: 0 0 0.75rem;
  }
}

.modal-aviso-fechar {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  border: none;
  background: none;
  font-size: 1.6rem;
  line-height: 1;
  color: #666;
  cursor: pointer;

  &:hover {
    color: #115810;
  }
}

.modal-aviso-rodape {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

.modal-aviso-entendi {
  padding: 0.4rem 1.5rem;
  border: solid 0.09rem #115810;
  border-radius: 0.5rem;
  background-color: #115810;
  color: white;
  font-family: "Poppins-Regular";
  font-size: 0.95rem;
  cursor: pointer;

  &:hover,
  &:focus {
    background-color: white;
    color: #115810;
  }
}

.alto-contraste {
  .modal-aviso {
    background-color: #0d2b10;
    border: 1px solid #ffa900;
    border-top-width: 0.4rem;

    h2,
    .modal-aviso-conteudo,
    .modal-aviso-fechar {
      color: white;
    }
  }

  .modal-aviso-entendi {
    background-color: #ffa900;
    border-color: #ffa900;
    color: black;
  }
}
</style>
